import { Link } from '~/utils/navigation';
import useContextualPathTransformer from '../../hooks/use-contextual-path-transformer.js';
/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {React.MouseEventHandler} [props.onClick]
 * @param {string | object} [props.to]
 * @param {string} [props.href]
 * @param {string} [props.className]
 */
function Anchor({ children, onClick, href, to, innerRef, state, ...rest }) {
	const transformPath = useContextualPathTransformer();
	if (onClick) {
		return (
			<button type="button" style={{ position: 'relative' }} onClick={onClick} {...rest}>
				{children}
			</button>
		);
	}
	if (href) {
		return (
			<a href={href} {...rest}>
				{children}
			</a>
		);
	}
	if (to) {
		return (
			<Link href={transformPath(to)} innerRef={innerRef} state={state} {...rest}>
				{children}
			</Link>
		);
	}
	return null;
}

export default Anchor;
